/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GuaranteeDto } from './GuaranteeDto';
import {
    GuaranteeDtoFromJSON,
    GuaranteeDtoFromJSONTyped,
    GuaranteeDtoToJSON,
    GuaranteeDtoToJSONTyped,
} from './GuaranteeDto';
import type { BorrowerContractFunnelDto } from './BorrowerContractFunnelDto';
import {
    BorrowerContractFunnelDtoFromJSON,
    BorrowerContractFunnelDtoFromJSONTyped,
    BorrowerContractFunnelDtoToJSON,
    BorrowerContractFunnelDtoToJSONTyped,
} from './BorrowerContractFunnelDto';
import type { SidebarComponentDto } from './SidebarComponentDto';
import {
    SidebarComponentDtoFromJSON,
    SidebarComponentDtoFromJSONTyped,
    SidebarComponentDtoToJSON,
    SidebarComponentDtoToJSONTyped,
} from './SidebarComponentDto';
import type { BorrowerPricingHeaderInfoDto } from './BorrowerPricingHeaderInfoDto';
import {
    BorrowerPricingHeaderInfoDtoFromJSON,
    BorrowerPricingHeaderInfoDtoFromJSONTyped,
    BorrowerPricingHeaderInfoDtoToJSON,
    BorrowerPricingHeaderInfoDtoToJSONTyped,
} from './BorrowerPricingHeaderInfoDto';

/**
 * Response for init-comparateur endpoint with flat structure
 * @export
 * @interface GetBorrowerPricingDataDto
 */
export interface GetBorrowerPricingDataDto {
    /**
     * 
     * @type {BorrowerPricingHeaderInfoDto}
     * @memberof GetBorrowerPricingDataDto
     */
    headerInfo: BorrowerPricingHeaderInfoDto;
    /**
     * 
     * @type {Array<BorrowerContractFunnelDto>}
     * @memberof GetBorrowerPricingDataDto
     */
    contractFunnels?: Array<BorrowerContractFunnelDto>;
    /**
     * 
     * @type {Array<GuaranteeDto>}
     * @memberof GetBorrowerPricingDataDto
     */
    guarantees?: Array<GuaranteeDto>;
    /**
     * 
     * @type {Array<SidebarComponentDto>}
     * @memberof GetBorrowerPricingDataDto
     */
    sidebar?: Array<SidebarComponentDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBorrowerPricingDataDto
     */
    warningMessages?: Array<string>;
}

/**
 * Check if a given object implements the GetBorrowerPricingDataDto interface.
 */
export function instanceOfGetBorrowerPricingDataDto(value: object): value is GetBorrowerPricingDataDto {
    if (!('headerInfo' in value) || value['headerInfo'] === undefined) return false;
    return true;
}

export function GetBorrowerPricingDataDtoFromJSON(json: any): GetBorrowerPricingDataDto {
    return GetBorrowerPricingDataDtoFromJSONTyped(json, false);
}

export function GetBorrowerPricingDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBorrowerPricingDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'headerInfo': BorrowerPricingHeaderInfoDtoFromJSON(json['headerInfo']),
        'contractFunnels': json['contractFunnels'] == null ? undefined : ((json['contractFunnels'] as Array<any>).map(BorrowerContractFunnelDtoFromJSON)),
        'guarantees': json['guarantees'] == null ? undefined : ((json['guarantees'] as Array<any>).map(GuaranteeDtoFromJSON)),
        'sidebar': json['sidebar'] == null ? undefined : ((json['sidebar'] as Array<any>).map(SidebarComponentDtoFromJSON)),
        'warningMessages': json['warningMessages'] == null ? undefined : json['warningMessages'],
    };
}

export function GetBorrowerPricingDataDtoToJSON(json: any): GetBorrowerPricingDataDto {
    return GetBorrowerPricingDataDtoToJSONTyped(json, false);
}

export function GetBorrowerPricingDataDtoToJSONTyped(value?: GetBorrowerPricingDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headerInfo': BorrowerPricingHeaderInfoDtoToJSON(value['headerInfo']),
        'contractFunnels': value['contractFunnels'] == null ? undefined : ((value['contractFunnels'] as Array<any>).map(BorrowerContractFunnelDtoToJSON)),
        'guarantees': value['guarantees'] == null ? undefined : ((value['guarantees'] as Array<any>).map(GuaranteeDtoToJSON)),
        'sidebar': value['sidebar'] == null ? undefined : ((value['sidebar'] as Array<any>).map(SidebarComponentDtoToJSON)),
        'warningMessages': value['warningMessages'],
    };
}

